import React from 'react';

import { useIsLocalizationEnabled } from 'hooks/use-is-localization-enabled';

import LanguageSelector from '../components/language-selector';
import SignUp from '../sign-up';

import { SignUpPanel } from './sign-up-home.styled';
import { AuthenticationTabProps } from './types';

const SignupTab = React.memo(({ showOtpForm, extraFields }: AuthenticationTabProps) => {
  const isLocalizationEnabled = useIsLocalizationEnabled();

  return (
    <SignUpPanel>
      <SignUp skipRedirect={!!showOtpForm} authCampaignExtraFields={extraFields} />
      {isLocalizationEnabled && <LanguageSelector />}
    </SignUpPanel>
  );
});

export default SignupTab;
